import { inject, Injectable } from '@angular/core';
import { SQLiteService } from './sqlite.service';
import { ClientsServiceDB } from '@core/services/database/client.service';
import { TransactionsServiceDB } from '@core/services/database/transactions.service';
import { isPlatform } from '@ionic/angular';
import { DbnameVersionService } from '@core/services/database/dbname-version.service';
import { capSQLiteVersionUpgrade } from '@capacitor-community/sqlite/src/definitions';
import { SQLiteDBConnection } from '@capacitor-community/sqlite';
import { dbVersionUpgrades } from '@core/services/database/upgrades/upgrade-db';
import { ClientOperationsService } from '@core/services/database/client-operations.service';

@Injectable({
  providedIn: 'root'
})
export class InitializeAppService {
  isAppInit: boolean = false;
  protected sqliteService: SQLiteService = inject(SQLiteService);
  protected dbVerService: DbnameVersionService = inject(DbnameVersionService);
  public databaseName = 'prime';
  protected versionUpgrades: capSQLiteVersionUpgrade[] = [
    {
      toVersion: 1,
      statements: []
    }
  ];
  protected loadToVersion = 1;
  public mDb!: SQLiteDBConnection;

  constructor(
    private clientsServiceDB: ClientsServiceDB,
    private transactionsServiceDB: TransactionsServiceDB,
    private clientOperationsService: ClientOperationsService
  ) {
    this.versionUpgrades = dbVersionUpgrades;
    this.loadToVersion =
      dbVersionUpgrades[dbVersionUpgrades.length - 1].toVersion;
  }

  async initializeApp(): Promise<void> {
    try {
      await this.sqliteService.initializePlugin();

      if (!isPlatform('hybrid')) {
        await this.sqliteService.initWebStore();
      }

      await this.sqliteService.addUpgradeStatement({
        database: this.databaseName,
        upgrade: this.versionUpgrades
      });

      const isEncrypted =
        this.sqliteService.native &&
        (await this.sqliteService.isInConfigEncryption()).result &&
        (await this.sqliteService.isDatabaseEncrypted(this.databaseName)).result || false;

      this.mDb = await this.sqliteService.openDatabase(
        this.databaseName,
        isEncrypted,
        isEncrypted ? 'secret' : 'no-encryption',
        this.loadToVersion,
        false
      );

      await Promise.all([
        this.clientsServiceDB.initializeDatabase(
          this.databaseName,
          this.loadToVersion,
          this.mDb
        ),
        this.transactionsServiceDB.initializeDatabase(
          this.databaseName,
          this.loadToVersion,
          this.mDb
        ),
        this.clientOperationsService.initializeDatabase(
          this.databaseName,
          this.loadToVersion,
          this.mDb
        )
      ]);

      this.dbVerService.set(this.databaseName, this.loadToVersion);
      console.log('Success initializing app DB:');
      this.isAppInit = true;
    } catch (error) {
      console.error('❌ Error initializing app DB:', error);
      this.isAppInit = false;
      throw error;
    }
  }

}
